import {useState, useEffect, useMemo} from 'react';
import { useTheme } from '@mui/material';
import Select from 'react-select';
import CalendarioV2Service from '../../services/calendarioV2.service';

const SelectLugaresCalendar = ({id, value, onChange, isInvalid, isClearable, isMulti,disabled}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [options, setOptions] = useState([]);
    const [items, setItems] = useState([]);
    const [selectedValue, setSelectedValue] = useState();
    const actualizar = async() =>{
        await CalendarioV2Service.lugaresCalendar().then((resp)=>{
            setItems(resp)
        })
        .catch((err)=>{
            setItems([])
        })
    }

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        if(ev){
            onChange(ev);
        } else {
            onChange(null);
        }
    };

    useEffect(() => {
        if(items.length > 0){
            const newOptions = items?.map((item) => {
                return { ...item, value: item.id, label: item.nombre };
            });
            setOptions(newOptions);
        }else{
            setOptions([])
        }
    }, [items]);

    useEffect(() => {
        if( options.length > 0 ){
            if(typeof value === 'string' || typeof value === 'number'){
                setSelectedValue(
                    options.find((opt) => opt.value === Number(value))
                );
            }else if(Array.isArray(value)){
                setSelectedValue(value.map(va=>{
                    const item = items.find(it=>it.id === va);
                    if(item){
                        return {
                            value:item.id,
                            label:item.nombre
                        };
                    }
                    return null
                }))
            }
        }
    }, [options,value])
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (base) => ({
            ...base,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0'
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : isDarkMode ? '#e0e0e0' : '#000',
            background: state.isSelected ? (isDarkMode ? '#1a3a5c' : '#0364ff') : isDarkMode ? '#2d3a52' : '#fff',
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: isDarkMode ? '#90caf9' : '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5,
                border: isDarkMode ? '1px solid #fff' : 'none',
                border: isDarkMode ? '1px solid #fff' : 'none',
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            '&:hover': {
                borderColor: isDarkMode ? '#64B5F6' : '#0364ff'
            }
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000'
        }),
        input: (styles) => ({
            ...styles,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (styles) => ({
            ...styles,
            color: isDarkMode ? '#b0bec5' : 'gray',
        })
    }), [isDarkMode])
    useEffect(() => {
        actualizar()
    }, [])
    return (
        <Select
            isDisabled={disabled}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
            isMulti={isMulti}
        />
    );
};

SelectLugaresCalendar.defaultProps = {
    isClearable: false
};

export default SelectLugaresCalendar

